import { DestinationFormData } from '@/types/destinationFormData'

export const initialDestinationFormData: DestinationFormData = {
  id: 0,
  destinationCode: '',
  name: '',
  postalCode1: '',
  postalCode2: '',
  postalCode: '',
  addressLine1: '',
  addressLine2: '',
  prefectureCode: '',
  phoneNumber: '',
  destinationsPhoneNumber: '',
  faxNumber: '',
  startDate: '',
}
